import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import { PREDIKAT_KINERJA_LABEL } from 'app/KinerjaShared/constants/penetapanPredikatKinerja'

import type {
  PenetapanPredikatKinerjaStoreItem,
  PredikatKinerjaTypes,
} from 'app/KinerjaShared/stores/penetapan-predikat-kinerja-store'

export const PREDIKAT_STYLES: Record<PredikatKinerjaTypes, string> = {
  VERY_GOOD: 'bg-green-20',
  GOOD: 'bg-green-5',
  NEED_IMPROVEMENT: 'bg-orange-10',
  BAD: 'bg-red-5',
  VERY_BAD: 'bg-red-20',
  UNFINISHED_PENILAIAN: 'bg-white border border-disabled',
  PREDIKAT_NOT_SET: 'bg-surface-neutral-subdued',
}

export const PREDIKAT_LABEL: Record<PredikatKinerjaTypes, string> = {
  ...PREDIKAT_KINERJA_LABEL,
  UNFINISHED_PENILAIAN: 'Penilaian Belum Selesai',
  PREDIKAT_NOT_SET: 'Belum Ditetapkan',
}

export function PredikatBadge({
  item,
}: {
  item: PenetapanPredikatKinerjaStoreItem
}) {
  const label = PREDIKAT_LABEL[item.predikat]
  const style = PREDIKAT_STYLES[item.predikat]

  if (!label) {
    return <span>-</span>
  }

  return (
    <Text
      as="span"
      variant="body-sm-bold"
      className={clsx(
        'whitespace-nowrap rounded-full py-0.5 px-2 inline-block box-border h-6',
        style
      )}
    >
      {label}
    </Text>
  )
}
